export abstract class ClaimTypes {
  static readonly Organization = 'orgId';
}
